let Photos1980=[
  {
    "NameEN": "1980",
    "Image": "un20",
    "CaptionEN": "Palestinians killed in the Sabra and Shatila massacre following the Israeli invasion of Lebanon, 1982 [Getty Images]",
    "CaptionAR": "قتلى فلسطينيون في مذبحة صبرا وشاتيلا في أعقاب الاجتياح الإسرائيلي للبنان عام 1982 (غيتي)"
  },
  {
    "NameEN": null,
    "Image": "un28",
    "CaptionEN": "An American soldier captured in Nicaragua, 1986 [Getty Images]",
    "CaptionAR": "جندي أميركي أسير في نيكاراغوا عام 1986 (غيتي)"
  },
  {
    "NameEN": null,
    "Image": "un22",
    "CaptionEN": "A whites-only beach in South Africa under apartheid, 1988 [Getty Images]",
    "CaptionAR": "للبيض فقط.. شاطئ في جنوب أفريقيا في حقبة الفصل العنصري عام 1988 (غيتي)"
  },
  {
    "NameEN": null,
    "Image": "un21",
    "CaptionEN": "Soviet General Secretary Mikhail Gorbachev with US President Ronald Reagan, 1987 [Getty Images]",
    "CaptionAR": "الأمين العام للحزب الشيوعي السوفياتي ميخائيل غورباتشوف والرئيس الأميركي رونالد ريغن عام 1987 (غيتي)"
  }
]
export default Photos1980